import React from 'react';
import classes from './SectionMenu.css';
import { NavLink } from 'react-router-dom';

const sectionMenu = props => {
    return (
        <ul className={classes.MenuList}>
            {props.menuItems.map((item, i) => (
                <li key={i}>
                    <NavLink
                        exact
                        to={item.link}
                        activeClassName={classes.ActiveMenu}
                    >
                        {item.label}
                    </NavLink>
                </li>
            ))}
        </ul>
    );
};

export default sectionMenu;



// WEBPACK FOOTER //
// ./src/components/SectionMenu/SectionMenu.js